import { CSSProperties, ReactNode } from "react";
import { AppBox, AppPaper, AppText, AppTitle } from "..";
import { ShadowSizes, SurfaceColors, TextColors } from "../../types/core-types";
interface InfoProps {
  title: string | number;
  label: string;
  titleColor?: TextColors;
  paperBgColor?: SurfaceColors;
  alignItems?: CSSProperties["alignItems"];
  shadow?: ShadowSizes;
  icon?: ReactNode;
  rightSide?: ReactNode;
  withBorder?: boolean;
  cardLink?: string;
}
export default function InfoCard({
  title,
  label,
  titleColor,
  paperBgColor = 100,
  alignItems = "center",
  shadow = "none",
  icon,
  rightSide,
  withBorder,
  cardLink,
}: InfoProps) {
  const alignmentMapping: { [key: string]: CSSProperties["textAlign"] } = {
    center: "center",
    "flex-start": "left",
    start: "left",
    "flex-end": "right",
    end: "right",
  };

  const textAlign = alignmentMapping[alignItems];

  const handleLinkClick = () => {};

  return (
    <AppPaper
      shadow={shadow}
      radius="sm"
      bgColor={paperBgColor}
      padding="xs"
      withBorder={withBorder}
      style={{ alignContent: "center" }}
    >
      <AppBox
        gap="xs"
        alignItems="center"
        justifyContent="center"
        className={`flex-1 ${cardLink && "clickable"}`}
        onClick={handleLinkClick}
      >
        {icon && icon}
        <AppBox flexDirection="column" alignItems={alignItems} className="flex-1">
          <AppTitle textAlign={textAlign} as={"h5"} color={titleColor}>
            {title}
          </AppTitle>
          <AppText textAlign={textAlign} as="label" size="sm" color="muted">
            {label}
          </AppText>
        </AppBox>
        {rightSide && rightSide}
      </AppBox>
    </AppPaper>
  );
}
